import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=d6300186"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
import style0 from "./Page.vue?vue&type=style&index=0&id=d6300186&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/vercel/path0/components/page/Header.vue').default,Modal: require('/vercel/path0/components/elements/Modal/index.vue').default,CtaFixedMenu: require('/vercel/path0/components/elements/CtaFixedMenu.vue').default,BookingBtns: require('/vercel/path0/components/elements/BookingBtns.vue').default,PageFooter: require('/vercel/path0/components/page/Footer.vue').default})
